import BSNavbar from "../../component/Navbar/Navbar";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaSearch } from 'react-icons/fa'
import { BsArrowRightCircleFill } from 'react-icons/bs'
import { Form, Stack } from "react-bootstrap";
import BulletinData from "../../util/BulletinData";
import BulletinItem from "../../component/BulletinItem/BulletinItem";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { update } from "../../features/searchKeyword/searchKeyword";
import { selectWindowWidth } from "../../features/windowWidth/windowWidth";
import { useState } from "react";
import './Home.css'

const search_api_url = process.env.REACT_APP_API_URL + "/comments/search";

const Home = () => {
  const [localSearch, setLocalSearch] = useState('');
  const navigate = useNavigate();
  const windowWidth = useSelector(selectWindowWidth);
  const dispatch = useDispatch();

  const handleSearch = async () => {
    await fetch(`${search_api_url}?q=${localSearch}&page=0`).then(res => {
      if (res.status === 404) {
        alert('搜尋不到，請嘗試其他關鍵字><');
      } else {
        dispatch(update(localSearch));
        navigate('/comment');
      }
    });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSearch();
  }

  return (
    <>
      <BSNavbar />
      <div
        className='cover'
        style={{ height: windowWidth > 1200 ? '40vh' : '30vh', minHeight: windowWidth > 1200 ? '400px' : '200px' }}
      >
        <h1
          style={{
            marginBottom: windowWidth > 1200 ? '80px' : '30px',
            fontSize: windowWidth > 1200 ? '40px' : windowWidth > 600 ? '30px' : windowWidth > 400 ? '20px' : '17px',
            fontWeight: '400'
          }}
        >
          借鏡學長姐的經驗，成為交大選課大師
        </h1>
        <Form
          className='input'
          style={{
            width: windowWidth > 1200 ? '600px' : windowWidth > 600 ? '400px' : windowWidth > 400 ? '300px' : '250px',
            height: windowWidth > 1200 ? '50px' : '40px',
          }}
          onSubmit={handleSubmit}
        >
          <FaSearch className="me-2" size={20} style={{ color: '#ef629f' }} />
          <input
            style={{ fontSize: windowWidth > 1200 ? '20px' : '15px' }}
            placeholder="你好，找哪位？"
            autoFocus
            onChange={(e) => setLocalSearch(e.target.value)}
          />
          <BsArrowRightCircleFill
            size={30}
            type='submit'
            className="me-2 send-icon"
            onClick={handleSearch}
          />
        </Form>
      </div>
      <Stack
        direction={windowWidth > 1200 ? "horizontal" : 'vertical'}
        className="mt-5 mb-5"
        gap={5}
        style={{ marginLeft: windowWidth > 1200 ? '100px' : '30px', marginRight: windowWidth > 1200 ? '100px' : '30px' }}
      >
        <Stack gap={4}>
          {BulletinData.map((data, idx) => (
            /*idx % 2 === 0 && */ (
              <BulletinItem key={idx} idx={idx} data={data} windowWidth={windowWidth} />
            )
          ))}
        </Stack>
        {/* <Stack gap={4} style={{ marginRight: windowWidth > 1200 && '100px' }}>
          {BulletinData.map((data, idx) => (
            idx % 2 === 1 && (
              <BulletinItem key={idx} idx={idx} data={data} windowWidth={windowWidth} />
            )
          ))}
        </Stack> */}
      </Stack>
    </>
  )
}

export default Home;